import '../table/data-table.scss';
import { TableHTMLAttributes } from 'react';
import { PaginationRequest } from '../../clients/quipli-service/pagination/pagination';
import { PaginatorProps } from '../paginator/paginator';
import { ReactNode } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { SortableDesktopDataTable } from './desktop-data-table';
import { MobileDataTable } from './mobile-data-table';

export type DataTableColumn = {
  key: string;
  label?: string | JSX.Element | ReactNode;
  hide?: boolean;
  showRule?: 'OnlyMobile' | 'OnlyDesktop' | 'Both';
  mobileShowRule?: 'fullrow' | 'halfrow';
  fixedAsFirst?: boolean;
  fixedAsLast?: boolean;
  isCheckBoxColumn?: boolean;
  className?: string;
};

export type DataTableRow = {
  className?: string;
  redirectTo?: string;
  mobileHeader: string | JSX.Element | ReactNode;
  mobileHeaderAction?: string | JSX.Element | ReactNode;
  fields: Record<string, string | JSX.Element | ReactNode>;
  data?: any;
  extraRow?: {
    content: string | JSX.Element | ReactNode;
    className?: string;
  };
};

export type DataTableProps<TPaginator extends PaginationRequest> = TableHTMLAttributes<HTMLTableElement> &
  Partial<PaginatorProps<TPaginator>> & {
    data: DataTableRow[];
    dataItems: any[];
    setNewDataItemsOrder: (newDataItemsOrder: any[]) => void;
    columnNames: DataTableColumn[];
    showAlwaysDesktop?: boolean;
    title?: { text: string; className?: string };
    tabs?: JSX.Element | ReactNode;
    noDataText?: string;
    isLoading?: boolean;
    wrapperClassNames?: string;
    onCheckBoxSelect?: (selectedData: any[]) => void;
    checkBoxActions?: JSX.Element | ReactNode;
  };

export const SortableDataTable = <TPaginator extends PaginationRequest>({
  showAlwaysDesktop,
  ...props
}: DataTableProps<TPaginator>) => {
  return isMobileOnly && !showAlwaysDesktop ? <MobileDataTable {...props} /> : <SortableDesktopDataTable {...props} />;
};
